const DISPLAY_NAME: Record<string, string> = {
  CARDIOVISION: 'CardioVision',
  'CARDIOVISION-V2': 'CardioVision v2',
  MITRALVISION: 'MitralVision',
  ECHOMEASURE: 'EchoMeasure',
  'ECHOMEASURE-V2': 'EchoMeasure v2',
};

/** Display name of an AI product; unknown values are shown as received. */
export const aiProductName = (product: string): string =>
  DISPLAY_NAME[product] ?? product;
